import { Link, styled } from "@/theme/index";

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: "bold",
}));
